import '@/pages/artwork/content-section/socials/artwork-thoughts/components/ThoughtInput'; // Reuse ThoughtInput styles

import { useRef } from 'react';

import useStateHandler from '@/hooks/useStateHandler';
import UserProfileImage from '@/shared-components/cards/components/UserProfileImage';
import UploadArrowUp from '@/shared-components/icons/components/actions/UploadArrowUp';

import './styles/ConversationInput.css';

export default function ConversationInput({ sendMessage }) {
  const textareaRef = useRef();
  const { state } = useStateHandler();

  function resizeTextarea() {
    if (textareaRef.current) {
      // Reset rows to recalc scrollHeight correctly
      textareaRef.current.setAttribute('rows', '1');
      const lineHeight = parseInt(window.getComputedStyle(textareaRef.current).lineHeight);
      const numRows = Math.ceil(textareaRef.current.scrollHeight / lineHeight);
      textareaRef.current.setAttribute('rows', numRows);
    }
  }

  function onSendMessage() {
    const message = textareaRef.current.value.trim();
    if (message.length === 0) return;
    sendMessage(message);
    textareaRef.current.value = "";
    resizeTextarea();
  }

  return (
    <form 
      onSubmit={e => { e.preventDefault(); onSendMessage(); }} 
      className="artwork-view-thoughts__input-container conversation"
    >
      <UserProfileImage 
        typeOfProfile={state?.user_session?.user_type} 
        className="artwork-view-thoughts__profile_img" 
        image={state?.user_session?.user_image?.image_id} 
      />
      <div className="artwork-view-thoughts__textarea-outter-container">
        <div className="artwork-view-thoughts__textarea-container">
          <textarea 
            placeholder="Start chatting"
            className="artwork-view-thoughts__textarea remove-scrollbar"
            rows="1"
            onInput={resizeTextarea}
            ref={textareaRef}
            spellCheck={false}
          />
        </div>
      </div>
      <button 
        type="submit" 
        className="artwork-view-thoughts__publish-thought"
      >
        <div className="artwork-view-thoughts__publish-thought-circle">
          <UploadArrowUp />
        </div>
      </button>
    </form>
  );
}
